import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { usePermissions } from './usePermissions';
import { getVisiblePartnerTools, type PartnerWorkspaceTool } from '../navigation/partnerWorkspace';

/**
 * The partner tools this account is offered. The phone More screen and the
 * desktop sidebar both read this, so one shell cannot list a tool the other
 * hides (Ask Ellie and Insights used to show on desktop regardless).
 */
export function usePartnerVisibleTools(): PartnerWorkspaceTool[] {
  const account = useSelector((s: RootState) => (s.session as any)?.account);
  const flags = useSelector((s: RootState) => s.featureFlags.flags);
  const flagsFetched = useSelector((s: RootState) => s.featureFlags.fetched);
  const { hasAnyAccount } = usePermissions();
  const canUseAccountChat = (!flagsFetched || flags?.ai_account_chat_enabled !== false)
    && hasAnyAccount('administrator', 'owner', 'account-chat');
  const features = account?.features;
  const isPartnerAccount = !!account?.partner;

  return useMemo(
    () => getVisiblePartnerTools({ features, isPartnerAccount, canUseAccountChat }),
    [features, isPartnerAccount, canUseAccountChat],
  );
}
